// :: Templates ------------ //

// :: Blocks ------------ //

// :: Modules ------------ //
import cookieConsent from './modules/CookieConsent';

// :: Components ------------ //
import avalanche from '@components/avalanche/Avalanche';

// :: Utilities ------------ //

export default () => {
    // :: Templates ------------ //

    // :: Blocks ------------ //

    // :: Modules ------------ //
    window.cookieConsent = cookieConsent;

    // :: Components ------------ //
    avalanche();

    // :: Utilities ------------ //
};
